import { PurchaseDetail, PurchaseFormValues } from "../../../types/purchases/BasePurchase";


export function mapTaxCredit(purchase: PurchaseDetail): PurchaseFormValues {
  return {
    id: purchase.id,
    documentNumber: purchase.documentNumber,
    purchaseDate: purchase.purchaseDate,
    supplier: purchase.supplier,
    documentType: purchase.documentType,
    comments: purchase.comments || '',
    cancellationReason: purchase.cancellationReason || '',

    products: purchase.taxCreditProducts || [],
    taxableSubtotal: purchase.taxableSubtotal || 0,
    calculatedIVA: purchase.calculatedIVA || 0,
    withheldIVA: purchase.withheldIVA || 0,
    total: purchase.total || 0,

    paymentCondition: purchase.paymentCondition || null,
  };
}
